import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
  confirmMessage: {
    fontWeight: 600,
    marginBottom: 12,
  },
  confirmDialogContent: {
    display: "flex",
    flexDirection: "column",
  },
});

const ConfirmationDialogContent = ({ routeData, proId, classes }) => {
  return (
    <div className={classes.confirmDialogContent}>
      <span className={classes.confirmMessage}>
        {`Please confirm if you would like to remove Pro# ${proId} from
                ${routeData?.driverName} (# ${routeData?.driverNumber})`}
      </span>
    </div>
  );
};

export default withStyles(styles)(ConfirmationDialogContent);
